import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { CartOfferLine } from '~shared/modules/shopping-cart-store';
import { ITotal } from '~shared/modules/cart/models';
import { OrderPayment } from '~app/modules/checkout/models';

export class PurchaseApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.Purchase;

  constructor(
    protected offerLines: CartOfferLine[],
    protected totals: ITotal,
    protected orderPayment: OrderPayment,
    protected priceType: string
  ) {}

  getPayload(): any {
    return {
      offerLines: this.offerLines,
      totals: this.totals,
      orderPayment: this.orderPayment,
      price_type: this.priceType
    };
  }
}
